<template>
    <div class="mb-8">
        <ul class="mt-3 grid grid-cols-1 gap-5 sm:gap-6 sm:grid-cols-3 lg:grid-cols-3">
            <li>
                <a class="col-span-1 flex shadow-sm rounded-md">
                    <div
                        class="flex-shrink-0 flex items-center justify-center w-16 bg-primary text-white text-sm font-medium rounded-l-md">
                        B
                    </div>
                    <div
                        class="flex-1 flex items-center justify-between border-t border-r border-b border-gray-200 bg-white rounded-r-md truncate">
                        <div class="flex-1 px-4 py-2 text-sm truncate">
                            <span class="text-gray-900 font-medium hover:text-gray-600">Benutzer</span>
                            <p class="text-gray-500"> Ø {{ averageUsers.toLocaleString("de-DE", {minimumFractionDigits: 2})}} </p>
                        </div>
                    
                        <div class="flex-shrink-0 pr-2 text-lg">
                            <i @click="showModal1 = true" class="fa fa-info-circle" aria-hidden="true"></i>
                            <portal to="modal" v-if="showModal1">
                                <modal @close="showModal1 = false">
                                    <template slot="header">
                                        Berechnung
                                    </template>
                                    <template slot="" >
                                        <p class="mb-4 font-semibold text-gray-500 text-sm justify-center"> Anzahl der im Zeitraum durchschnittlich registrierten Nutzer</p>
                                    </template>
                                    
                                </modal>
                            </portal>
                        </div>
                    </div>
                </a>
                
                
            </li>
            <li>
                <a class="col-span-1 flex shadow-sm rounded-md" >
                    <div
                        class="flex-shrink-0 flex items-center justify-center w-16 bg-primary text-white text-sm font-medium rounded-l-md">
                        S
                    </div>
                    <div
                        class="flex-1 flex items-center justify-between border-t border-r border-b border-gray-200 bg-white rounded-r-md truncate">
                        <div class="flex-1 px-4 py-2 text-sm truncate">
                            <span class="text-gray-900 font-medium hover:text-gray-600">Schreibtische</span>
                            <p class="text-gray-500"> Ø {{ Math.round(averageDesks).toLocaleString("de-DE", {minimumFractionDigits: 2}) }} </p>
                        </div>

                        <div class="flex-shrink-0 pr-2">
                            <i @click="showModal2 = true" class="fa fa-info-circle" aria-hidden="true"></i>
                            <portal to="modal" v-if="showModal2">
                                <modal @close="showModal2 = false">
                                    <template slot="header">
                                        Berechnung
                                    </template>
                                    <template slot="">
                                        <p class="mb-4 font-semibold text-gray-500 text-sm justify-center"> Anzahl der im Zeitraum durchschnittlich registrierten Schreibtische</p>
                                    </template>

                                </modal>
                            </portal>
                        </div>
                    </div>
                </a>
            </li>
            <li>
                <a class="col-span-1 flex shadow-sm rounded-md">
                    <div
                        class="flex-shrink-0 flex items-center justify-center w-16 bg-primary text-white text-sm font-medium rounded-l-md">
                        V
                    </div>
                    <div
                        class="flex-1 flex items-center justify-between border-t border-r border-b border-gray-200 bg-white rounded-r-md truncate">
                        <div class="flex-1 px-4 py-2 text-sm truncate">
                            <span class="text-gray-900 font-medium hover:text-gray-600">Verhältnis Nutzer zu
                                Schreibtisch</span>
                            <p class="text-gray-500"> 1 : {{ (Math.round(deskUserRatio * 100) / 100).toLocaleString("de-DE", {minimumFractionDigits: 2}) }} </p>
                        </div>
                        <div class="flex-shrink-0 pr-2">
                            <i @click="showModal3 = true" class="fa fa-info-circle" aria-hidden="true"></i>
                            <portal to="modal" v-if="showModal3">
                                <modal @close="showModal3 = false">
                                    <template slot="header">
                                        Berechnung
                                    </template>
                                    <p class="mb-4 font-semibold text-gray-500 text-sm justify-center">Anzahl der im Zeitraum durchschnittlich registrierten Benutzer, geteilt durch die Anzahl der im Zeitraum durchschnittlich registrierten Schreibtische</p>
                                </modal>
                            </portal>
                        </div>
                    </div>
                </a>
            </li>

            <li>
                <a class="col-span-1 flex shadow-sm rounded-md">
                    <div
                        class="flex-shrink-0 flex items-center justify-center w-16 bg-primary text-white text-sm font-medium rounded-l-md">
                        V
                    </div>
                    <div
                        class="flex-1 flex items-center justify-between border-t border-r border-b border-gray-200 bg-white rounded-r-md truncate">
                        <div class="flex-1 px-4 py-2 text-sm truncate">
                            <span class="text-gray-900 font-medium hover:text-gray-600">Verfügbare Schreibtische</span>
                            <p class="text-gray-500"> Ø {{ averageAvailableDesks.toLocaleString("de-DE", {minimumFractionDigits: 2}) }} </p>
                        </div>
                        <div class="flex-shrink-0 pr-2">
                            <i @click="showModal4 = true" class="fa fa-info-circle" aria-hidden="true"></i>
                            <portal to="modal" v-if="showModal4">
                                <modal @close="showModal4 = false">
                                    <template slot="header">
                                        Berechnung
                                    </template>
                                        <p class="mb-4 font-semibold text-gray-500 text-sm justify-center"> Durchschnittliche Anzahl aller im ausgewählten Zeitraum registrierten Schreibtische, davon abzüglich die Summe aller im ausgewählten Zeitraum getätigten Buchungen und fest vergebenen Schreibtische</p>                       
                                </modal>
                            </portal>
                        </div>
                    </div>
                </a>
            </li>
            <li>
                <a class="col-span-1 flex shadow-sm rounded-md">
                    <div
                        class="flex-shrink-0 flex items-center justify-center w-16 bg-primary text-white text-sm font-medium rounded-l-md">
                        V
                    </div>
                    <div
                        class="flex-1 flex items-center justify-between border-t border-r border-b border-gray-200 bg-white rounded-r-md truncate">
                        <div class="flex-1 px-4 py-2 text-sm truncate">
                            <span class="text-gray-900 font-medium hover:text-gray-600">Vermittelte
                                Schreibtische </span>
                            <p class="text-gray-500"> Ø {{ averageSchedules.toLocaleString("de-DE", {minimumFractionDigits: 2}) }} </p>
                        </div>
                        <div class="flex-shrink-0 pr-2">
                            <i @click="showModal5 = true" class="fa fa-info-circle" aria-hidden="true"></i>
                            <portal to="modal" v-if="showModal5">
                                <modal @close="showModal5 = false">
                                    <template slot="header">
                                        Berechnung
                                    </template>
                                        <p class="mb-4 font-semibold text-gray-500 text-sm justify-center"> Durchschnittliche Anzahl, aus den im ausgewählten Zeitraum getätigten Buchungen, zuzüglich der im ausgewählten Zeitraum fest vergebenen Schreibtische</p>                       
                                </modal>
                            </portal>
                        </div>
                    </div>
                </a>
            </li>
            <li>
                <a class="col-span-1 flex shadow-sm rounded-md">
                    <div
                        class="flex-shrink-0 flex items-center justify-center w-16 bg-primary  text-white text-sm font-medium rounded-l-md">
                        A
                    </div>
                    <div
                        class="flex-1 flex items-center justify-between border-t border-r border-b border-gray-200 bg-white rounded-r-md truncate">
                        <div class="flex-1 px-4 py-2 text-sm truncate">
                            <span class="text-gray-900 font-medium hover:text-gray-600"> Auslastung </span>
                            <p class="text-gray-500"> {{ (Math.round(averageOccupation * 100 )/ 100).toLocaleString("de-DE", {minimumFractionDigits: 2}) }} % </p>
                        </div>
                        <div class="flex-shrink-0 pr-2">
                            <i @click="showModal6 = true" class="fa fa-info-circle" aria-hidden="true"></i>
                            <portal to="modal" v-if="showModal6">
                                <modal @close="showModal6 = false">
                                    <template slot="header">
                                        Berechnung
                                    </template>
                                        <p class="mb-4 font-semibold text-gray-500 text-sm justify-center"> Verhältnis aus den im ausgewählten Zeitraum durchschnittlilch vermittelten Schreibtischen zu den im ausgewählten Zeitraum durchschnittlich verfügbaren Schrebtischen</p>                       
                                </modal>
                            </portal>
                        </div>
                    </div>
                </a>
            </li>
        </ul>
    </div>

</template>

<script>

import Modal from './Modal.vue';

export default {
    name: "KeyData",
    
    components: {
        Modal,
    },

       
    data: () => ({
        showModal1: false,
        showModal2: false,
        showModal3: false,
        showModal4: false,
        showModal5: false,
        showModal6: false,
    }),

    props: ['users', 'desks', 'bookings', 'permanentBookings'],

    computed: {
        averageUsers() {
            return  this.users.reduce((acc, curr) => acc + curr, 0) / this.users.length;
        },
        averageDesks() {
            return this.desks.reduce((a, b) => a + b, 0) / this.desks.length;
        },
        averageAvailableDesks() {
            return ((this.desks.reduce((a, b) => a + b, 0) / this.desks.length) - (this.bookings.reduce((a, b) => a + b, 0) / this.bookings.length) - ((this.permanentBookings.reduce((a, b) => a + b, 0) / this.permanentBookings.length)));
        },
        averageSchedules() {
            return (this.bookings.reduce((a, b) => a + b, 0) + this.permanentBookings.reduce((a, b) => a + b, 0)) / this.bookings.length; 
        },
        averageOccupation() {
            return ((this.averageSchedules) / this.averageDesks) * 100;
        },
        deskUserRatio() {
            return this.averageDesks / this.averageUsers;
        },  
    },


}
</script>

<style>

</style>
